module.exports = __webpack_public_path__ + "static/media/Acheive7.8fbac880.jpg";